import { getEnv } from '../utilities'
import auth from '../auth'
import { dateFilters } from '../filters/date-filters'

const apiBaseUrl = getEnv('VUE_APP_MSA_PDF_API_URL')

export async function generatePdf (configuration = {}, fields = {}) {
  const {
    pdfTemplateName,
    jsonTemplateName,
    serialNo
  } = configuration

  const data = {
    pdfTemplateName,
    jsonTemplateName,
    serialNo,
    fields
  }

  const request = {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${auth.user.token_type} ${auth.user.access_token}`
    },
    body: JSON.stringify(data)
  }

  const url = new URL('forms/pdf', apiBaseUrl)
  const response = await window.fetch(url, request)
  return await response.json()
}

export async function generateTrainingCertificatePdf (assessments = []) {
  const configuration = {
    pdfTemplateName: 'msa-licence-certificate-statement-of-attainment-template-v2.0.pdf',
    jsonTemplateName: 'msa-licence-certificate-statement-of-attainment-template.json'
  }
  const fields = {}

  // Get all assessments for the session (which is for one module, 1 to many units)
  let rowCount = 1
  const passedAsessments = assessments.filter(o => o.passed)
  for (const assessment of passedAsessments) {
    fields.name = assessment.person.name
    const unitDescription = assessment.session.module.units.find(o => o.code === assessment.unitCode).description
    Object.assign(fields, {
      [`unitCode${rowCount}`]: assessment.unitCode,
      [`unitDescription${rowCount}`]: unitDescription,
      [`completionDate${rowCount}`]: dateFilters.formatDate(assessment.session.completionDate)
    })
    rowCount++
  }

  return await generatePdf(configuration, fields)
}
